import React, { useContext, useState } from 'react'
import {
  RadioGroup,
  Radio,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Select,
  FormHelperText,
  Grid,
} from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import { Controller, useForm } from 'react-hook-form'
import { SessionContextStore } from '../../../context/SessionContext'
import { EventEmitterService, EventKey } from '../../../services/EventEmitterService'
import '../UserProfile.css'
import { UserProfileContextStore, ACTIONS } from '../../../context/UserProfileContext'
import { Action } from '../../../models/Action'
import { SessionService } from '../../../services/SessionService'
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService'
import { isUK } from '../../../services/utils'
import { isMobile } from 'react-device-detect'
import { YesNoRadioButton } from '../../Core/Buttons/ControlledRadioButtons'
import { INSURER_OPTIONS } from '../../../Constants'

export const InsuranceHistorySection = props => {
  const otherText = 'Other'
  const context = useContext(UserProfileContextStore)
  let sessionContext = useContext(SessionContextStore)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const { register, triggerValidation, setValue, control, errors, getValues, watch } = useForm({
    defaultValues: {
      ...sessionContext.user,
      is_commercial: sessionContext.user.commercial ? 'yes' : 'no',
      current_insurer: INSURER_OPTIONS.includes(sessionContext.user.currentInsurer) ? sessionContext.user.currentInsurer : otherText,
      other: INSURER_OPTIONS.includes(sessionContext.user.currentInsurer) ? undefined : sessionContext.user.currentInsurer,
    },
    mode: 'onChange',
  })

  let hadClaimWatch = watch('insurance_in_past_year', 'no')
  let watchOtherInsurer = watch('current_insurer')

  React.useEffect(() => {
    let id = EventEmitterService.subscribe(EventKey.USER_PROFILE_SAVE, async () => {
      const valid = await triggerValidation()
      if (valid) {
        let insuranceHistoryFormValues = getValues()
        if (insuranceHistoryFormValues['current_insurer'] === otherText) {
          insuranceHistoryFormValues['current_insurer'] = insuranceHistoryFormValues['other']
        }
        if (!insuranceHistoryFormValues['is_commercial']) {
          insuranceHistoryFormValues['is_commercial'] = sessionContext.user.commercial ? 'yes' : 'no'
        }
        context.dispatch(new Action(ACTIONS.SAVE_INSURANCE_HISTORY, { saved: true, ...insuranceHistoryFormValues }))
      }
    })

    return function cleanup() {
      EventEmitterService.unsubscribe(EventKey.USER_PROFILE_SAVE, id)
    }
  }, [])

  React.useEffect(() => {
    setValue(
      'insurance_in_past_year',
      sessionContext.user.insuranceInPastYear != undefined ? (sessionContext.user.insuranceInPastYear == true ? 'yes' : 'no') : ''
    )
    setValue('is_commercial', sessionContext.user.commercial ? 'yes' : 'no')
    setValue('current_insurer', sessionContext.user.currentInsurer)
  }, [sessionContext.user])

  const openConfirmDialog = () => setShowConfirmDialog(true)
  const closeConfirmDialog = () => setShowConfirmDialog(false)

  const changeSelection = () => {
    setValue('insurance_in_past_year', 'no')
    closeConfirmDialog()
  }

  return (
    <React.Fragment>
      <Grid contianer sm="12" lg="8">
        <YesNoRadioButton
          label={context.insurance_history_question}
          discount
          shouldFlex
          name="insurance_in_past_year"
          defaultValue={
            sessionContext.user.insuranceInPastYear != undefined ? (sessionContext.user.insuranceInPastYear == true ? 'yes' : 'no') : ''
          }
          register={register}
          control={control}
          errors={errors}
          watch={watch}
        />
      </Grid>

      {(hadClaimWatch == 'yes' || sessionContext.user.insuranceInPastYear == 'yes') && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Controller
                control={control}
                rules={{ validate: x => x && x != 'default', required: true }}
                name="current_insurer"
                defaultValue={sessionContext.user.currentInsurer || 'default'}
                as={
                  <TextField
                    InputLabelProps={{ className: 'avenir-book' }}
                    select
                    helperText={'Please indicate your current insurer'}
                    error={!!errors.current_insurer}
                    label={'Current Insurer'}
                    variant="outlined"
                    fullWidth
                    className="margin-bottom-basic margin-top-small"
                  >
                    {INSURER_OPTIONS.map(t => (
                      <MenuItem key={t} value={t}>
                        {t}
                      </MenuItem>
                    ))}
                  </TextField>
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              {watchOtherInsurer === 'Other' && (
                <>
                  <TextField
                    className="margin-bottom-basic margin-top-small"
                    variant="outlined"
                    label="Other"
                    autoComplete="other"
                    name="other"
                    inputRef={register({ required: true })}
                    error={!!errors.other}
                    helperText={!!errors.other && 'Required'}
                  />
                </>
              )}
            </Grid>
          </Grid>
        </>
      )}

      <Dialog
        open={showConfirmDialog}
        onClose={closeConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Unable to Provide Insurance</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Due to your claim history in the past 3 years, you will need to{' '}
            <a href={'mailto:support@skywatch.ai'} className="blue underline">
              contact our team
            </a>{' '}
            to proceed.
          </DialogContentText>
          <DialogContentText id="alert-dialog-description-2">
            If you have not had a claim in the past 3 years, please be sure to select No.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={changeSelection} color="primary">
            Change selection
          </Button>
          <Button onClick={closeConfirmDialog} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}
